import merge from 'lodash/merge';
import clone from 'lodash/clone';
import isMobile from '../lib/isMobile';
import fluxDefaults from './defaultsLarge';
import squareWalls from './partials/squareWalls';

const mobile = isMobile();

module.exports = merge(clone(fluxDefaults, true),
    squareWalls,
    {
        // gravity: 12,
        // particleScale: 0.6,
        // particlesRadius: 0.069,
        // initialTicks: 200,
        movingWalls: [

        ],
        blobs: [
            // main blobs
            {
                x: '0%',
                y: '0%',
                width: '100%',
                height: mobile ? '40%' : '40%',
                color: [0, 0, 0, 255],
            },
            {
                x: '0%',
                y: '50%',
                width: '100%',
                height: mobile ? '10%' : '10%',
                color: [255, 0, 0, 255],
            },
            {
                x: '0%',
                y: '60%',
                width: '100%',
                height: mobile ? '10%' : '10%',
                color: [0, 255, 0, 255],
            },
            {
                x: '0%',
                y: '70%',
                width: '100%',
                height: mobile ? '10%' : '10%',
                color: [0, 0, 255, 255],
            },
            {
                x: '0%',
                y: '80%',
                width: '100%',
                height: mobile ? '10%' : '10%',
                color: [0, 0, 0, 255],
            },
        ],
    },
);



// WEBPACK FOOTER //
// ./js/flux/introBrett.js